const BwIcon = () => {
  return (
    <svg
      width="23"
      height="22"
      viewBox="0 0 23 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.5 11C1.5 5.47715 5.97715 1 11.5 1V21C5.97715 21 1.5 16.5228 1.5 11Z"
        fill="black"
        stroke="black"
        strokeWidth="2"
      />
      <path
        d="M11.5 1C17.0228 1 21.5 5.47715 21.5 11C21.5 16.5228 17.0228 21 11.5 21V1Z"
        fill="white"
        stroke="black"
        strokeWidth="2"
      />
    </svg>
  )
}

export default BwIcon
